import React, { FC, PropsWithChildren, useState } from 'react';
import clsx from 'clsx';
import { ArrowSvg } from '../../Arrows/Arrows';

import './WidgetWrapper.less';

export interface WidgetWrapperProps {
    title?: string;
}

export const WidgetWrapper: FC<PropsWithChildren<WidgetWrapperProps>> = ({ title, children }) => {
    const [expanded, setExpanded] = useState(true);
    return (
        <div className="p-rel">
            {title && (
                <button
                    className="infocentre-holder-with-loader-title text-extra-bold py-10 px-20 fs-14 c-black-100 bg-black-5 full-width text-left flex justify-between align-middle"
                    onClick={title ? () => setExpanded(!expanded) : null}
                >
                    <div>{title}</div>
                    <ArrowSvg
                        otherClassName={clsx('arrow-orange infocentre-holder-with-loader-animated-arrow ml-8', {
                            'arrow-down': expanded,
                            'arrow-up': !expanded
                        })}
                        sizeY={'16px'}
                        sizeX={'16px'}
                    />
                </button>
            )}
            <div className={clsx({ 'infocentre-holder-with-loader-content': title, expanded })}>{children}</div>
        </div>
    );
};
